export const eSignatureSelector = ({ eSignatures: { eSignatureData: value } }) => value;
export const eSignatureDeletedSelector = ({ eSignatures: { eSignDeleted: value } }) => value;
export const eSignaturePropertySelector = ({ eSignatures: { eSignProperty: value = [] } }: any) => value;
export const eSignatureSharingSelector = ({ eSignatures: { eSignSharing: value } }: any) => value;
export const eSignatureSharedSelector = ({ eSignatures: { eSignShared: value } }: any) => value;
export const eSignatureCreatedSelector = ({ eSignatures: { eSignCreated: value } }: any) => value;

// form errors
export const emailErrorSelector = ({ eSignatures: { errors } }) => errors?.email || [];
